module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gk_aizn.531def8a.png";